import React from 'react';
const facts = [{
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '156',
  label: 'Sessions already decided'
}, {
  value: '45',
  label: 'Minutes, every class'
}, {
  value: '0',
  label: 'Decisions on Sunday night'
}];
export function SocialProofBar() {
  return <section className="w-full bg-navy" data-id="element-205" data-mp="25suajgoklzlz">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-206" data-mp="25tvnjqp5cw6c">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-navy-line bg-navy-line sm:grid-cols-4" data-id="element-207" data-mp="32iuun2dzvrwy">
          {facts.map(fact => <div key={fact.label} className="bg-navy px-4 py-5 text-center" data-id="element-208" data-mp="2xkteoqbv88pp">
              <div className="font-display text-3xl sm:text-4xl leading-none text-gold" data-id="element-209" data-mp="2th3ndt3t3d0z">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-white/60" data-id="element-210" data-mp="2olobh6pczr77">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}